import rxios from '../common/rxios'
import { map } from 'rxjs/operators'

export const serviceOverviewService = {
  getServiceOverview$(lang, parentHomepageUiName, homepageUiName, countryCode) {
    return rxios
      .get(`/homepage/v1/services/${parentHomepageUiName}/${homepageUiName}`, {
        params: {
          country: countryCode,
          lang: lang
        }
      })
      .pipe(map(response => response.data.serviceOverview))
  }
}
